// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__34N3L","alert":"SettungsInbox_alert__1xJID"};